export const staticOptionsArray = [
    {
        label: "DATE",
        value: "DATE"
    },
    {
        label: "TIME",
        value: "TIME"
    },
    {
        label: "DTM",
        value: "DTM"
    },
    {
        label: "INT",
        value: "INT"
    },
    {
        label: "BOOL",
        value: "BOOL"
    },
    {
        label: "ATT",
        value: "ATT"
    },
    {
        label: "DEC",
        value: "DEC"
    },
    {
        label: "TXT",
        value: "TXT"
    }
];
export const dateTimeTypeOptions = [
    {
        label: "Date",
        value: "date"
    },
    {
        label: "Time",
        value: "time"
    },
    {
        label: "Datetime",
        value: "datetime"
    }
];
export const typeOptionsArray = [
    {
        label: "Text",
        value: "text"
    },
    {
        label: "Textarea",
        value: "textarea"
    },
    {
        label: "Email",
        value: "email"
    },
    {
        label: "Search",
        value: "search"
    },
    {
        label: "Tel",
        value: "tel"
    },
    {
        label: "File",
        value: "file"
    },
    {
        label: "Number",
        value: "number"
    },
    {
        label: "Password",
        value: "password"
    },
    {
        label: "Url",
        value: "url"
    },
    {
        label: "Time",
        value: "time"
    },
    {
        label: "Date",
        value: "date"
    },
    {
        label: "DateTime",
        value: "datetime"
    }

];
export const togglesArrayCondensed = [
    {
        val: "hasType",
        label: "Type"
    },
    {
        val: "isCondensed",
        label: "Condensed"
    },
    {
        val: "hasValue",
        label: "hasValue"
    },
    {
        val: "hasStackLabel",
        label: "stackLabel"
    },
    {
        val: "hasFloatLabel",
        label: "floatLabel"
    },
    {
        val: "hasPlaceholder",
        label: "placeholder"
    },
    {
        val: "isClearable",
        label: "clearable"
    },
    {
        val: "isDisabled",
        label: "disabled"
    },
    {
        val: "isReadonly",
        label: "readonly"
    },
    {
        val: "hasError",
        label: "Error State"
    },
    {
        val: "hasErrorLabel",
        label: "Error label"
    },
    {
        val: "hasPrefix",
        label: "hasPrefix"
    },
    {
        val: "hasSuffix",
        label: "hasSuffix"
    },
    {
        val: "hasBefore",
        label: "hasBefore Icon"
    },
    {
        val: "hasAfter",
        label: "hasAfter Icon"
    },
    {
        val: "hasStaticBadge",
        label: "hasStaticBadge"
    },
    {
        val: "hasBeforeLabel",
        label: "hasLabelChip"
    },
    {
        val: "textareaFixedHeight",
        label: "has Textarea FixedHeight"
    },
    {
        val: "textareaAutogrow",
        label: "has Textarea Autogrow"
    }
];
export const chipToggles = [
    {
        val: "hasType",
        label: "Type"
    },
    {
        val: "isClearable",
        label: "clearable"
    },
    {
        val: "hasCustomIcon",
        label: "hasCustomIcon"
    }

];
export const chipTypeOptions = [
    {
        label: "default",
        value: "default"
    },
    {
        label: "unknownUser",
        value: "unknownUser"
    },
    {
        label: "disabledUser",
        value: "disabledUser"
    },
    {
        label: "user",
        value: "user"
    },
    {
        label: "group",
        value: "group"
    },
    {
        label: "file",
        value: "file"
    },
    {
        label: "m_datamodel",
        value: "m_datamodel"
    },
    {
        label: "s_datamodel",
        value: "s_datamodel"
    }
];
export const menuToggles = [
    {
        val: "addSearch",
        label: "addSearch"
    },
    {
        val: "disable",
        label: "disable"
    },
    {
        val: "fitParentContainer",
        label: "fitParentContainer"
    },
    {
        val: "resetSelectedData",
        label: "resetSelectedData"
    },
    {
        val: "closeOnSelection",
        label: "closeOnSelection"
    },
    {
        val: "hasCheckbox",
        label: "hasCheckbox"
    },
    {
        val: "separator",
        label: "separator"
    },
    {
        val: "isMultiselect",
        label: "isMultiselect"
    },
    {
        val: "hasAvatar",
        label: "hasAvatar"
    },
    {
        val: "hasError",
        label: "hasError"
    },
    {
        val: "hasBadge",
        label: "hasBadge"
    },
    {
        val: "hasChip",
        label: "hasChip"
    },
    {
        val: "hasTooltip",
        label: "hasTooltip"
    },
    {
        val: "leftIcon",
        label: "hasLeftIcon"
    },
    {
        val: "rightIcon",
        label: "hasRightIcon"
    },
    {
        val: "itemDisabled",
        label: "itemDisabled"
    },
    {
        val: "hasDescription",
        label: "hasDescription"
    },
    {
        val: "custom",
        label: "custom"
    }
];

export const dropdownToggles = [
    {
        val: "isSimple",
        label: "isSimple"
    },
    {
        val: "isMultiselect",
        label: "isMultiselect"
    },
    {
        val: "addSearch",
        label: "addSearch"
    },
    {
        val: "hasCheckbox",
        label: "hasCheckbox"
    },
    {
        val: "clearable",
        label: "clearable"
    },
    {
        val: "closeOnSelection",
        label: "closeOnSelection"
    },
    {
        val: "error",
        label: "error"
    },
    {
        val: "label",
        label: "label"
    },
    {
        val: "fitParentContainer",
        label: "fitParentContainer"
    },
    {
        val: "separator",
        label: "separator"
    },
    {
        val: "disable",
        label: "disable"
    },
    {
        val: "rounded",
        label: "rounded"
    },
    {
        val: "clearableChip",
        label: "clearableChip"
    },
    {
        val: "placeholder",
        label: "placeholder"
    },
    {
        val: "errorLabel",
        label: "errorLabel"
    },
    {
        val: "isReadonly",
        label: "isReadonly"
    }
];
